export class ExtendableError {
  constructor(message = null) {
    this.message = message;
    this.stack = (new Error()).stack;
  }
}

export class NotFoundError extends ExtendableError {}

export class VerificationError extends ExtendableError {
  message = 'reCAPTCHA verification failed';
}

export class ForbiddenError extends ExtendableError {}
